import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SourcePanelComponent } from './source-panel.component';
import { SourcePanelPipesModule } from '../../pipes/source-panel-pipes.module';

@NgModule({
  declarations: [SourcePanelComponent],
  imports: [CommonModule, FormsModule, TranslateModule, SourcePanelPipesModule],
  exports: [SourcePanelComponent]
})
export class SourcePanelModule { }
